import { styled } from '@mui/material/styles';
import {default as MuiSaveIcon} from "@mui/icons-material/Save";
import { Container, Modal } from '@mui/material';

export const StyledSaveModal = styled(Modal)(() => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}));

export const CloseSaveModal = styled('button')(({ theme }) => ({
    position: 'absolute',
    zIndex: 1000,
    top: 10,
    right: 10,
    color: theme.palette.text.secondary,
    borderColor: theme.palette.text.secondary,
    borderWidth: '1px',
    borderStyle: 'solid',
    background: 'transparent',
    cursor: 'pointer'
}));

export const HeadingContainer = styled(Container)(() => ({
    textAlign: 'center',
    paddingBottom: '20px'
}));

export const SaveIcon = styled(MuiSaveIcon)(() => ({
    transform: 'scale(1.8)',
    marginTop: '20px'
}));

export const SaveDraftForm = styled('form')(({ theme }) => ({
    margin: '0 0 10px',
    padding: '20px',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.divider}`,
    '& .MuiFormControlLabel-root': {
        margin: '0 0 10px'
    },
    '& .MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.text.secondary
    },
    '& .error-message': {
        color: '#ef4439',
        fontSize: theme.typography.pxToRem(12)
    },
    '& button': {
        marginTop: '10px'
    }
}));

export const SaveDraftGroup = styled('div')(() => ({
    margin: '0 0 10px'
}));

export const SaveDraftControlLabel = styled('label')(({ theme }) => ({
    width: '100%',
    margin: '0 0 7px 5px',
    fontSize: theme.typography.pxToRem(16)
}));

export const SaveDraftControl = styled('input')(({ theme }) => ({
    width: '100%',
    boxSizing: 'border-box',
    margin: '0 0 5px',
    padding: '16px',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    borderRadius: '4px',
    color: theme.palette.text.primary,
    lineHeight: '1.3',
    transition: '0.15s ease-in-out',
    '&::placeholder': {
        color: theme.palette.text.disabled
    },
    '&:focus': {
        outline: 'none'
    },
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.01)'
    }
}));